class BriefReadError extends Error {
 constructor(public status: number) { super('Failed to load brief'); }
}
export function briefQueryOptions(setId: number, request: typeof fetch = fetch) {
 return {
  queryKey: ['angle-set', setId],
  queryFn: async (): Promise<{set:{id:number;brandId:number}} | null> => {
   const response = await request(`/api/angle-sets/${setId}`, {credentials:'include'});
   if(response.status === 404) return null;
   if(!response.ok) throw new BriefReadError(response.status);
   return response.json();
  },
  retry: (failures: number, error: Error) => failures < 2 &&
   (!(error instanceof BriefReadError) || error.status === 429 || error.status >= 500),
  retryDelay: (attempt: number) => Math.min(1000 * 2 ** attempt, 4000),
 };
}
